import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _StimulusInfoBase;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { IconMoveDownBottomLine } from '@instructure/ui-icons';
import { Button } from '@instructure/ui-buttons';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import { onPhone, makeScrollable } from '@instructure/quiz-core';
import { RichContentRenderer } from '@instructure/quiz-rce';
import t from '@instructure/quiz-i18n/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
var StimulusInfoBase = /*#__PURE__*/function (_Component) {
  function StimulusInfoBase() {
    _classCallCheck(this, StimulusInfoBase);
    return _callSuper(this, StimulusInfoBase, arguments);
  }
  _inherits(StimulusInfoBase, _Component);
  return _createClass(StimulusInfoBase, [{
    key: "renderJumpToItemsButton",
    value: function renderJumpToItemsButton() {
      if (onPhone()) {
        return jsx(Button, {
          onClick: this.props.scrollToItems,
          renderIcon: IconMoveDownBottomLine
        }, jsx(ScreenReaderContent, null, t('View Items')));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var stimulus = this.props.stimulus;
      return jsx("div", {
        css: this.props.styles.info
      }, jsx("div", {
        css: this.props.styles.header
      }, jsx("div", {
        css: this.props.styles.title
      }, stimulus.title), jsx("div", {
        css: this.props.styles.jumpToItems
      }, this.renderJumpToItemsButton())), jsx(RichContentRenderer, {
        content: stimulus.body
      }));
    }
  }]);
}(Component);
_StimulusInfoBase = StimulusInfoBase;
_defineProperty(StimulusInfoBase, "displayName", 'StimulusInfoBase');
_defineProperty(StimulusInfoBase, "componentId", "Quizzes".concat(_StimulusInfoBase.displayName));
_defineProperty(StimulusInfoBase, "propTypes", {
  stimulus: ImmutablePropTypes.record.isRequired,
  scrollToItems: PropTypes.func.isRequired,
  styles: PropTypes.object
});
export var StimulusInfo = compose(makeScrollable, withStyleOverrides(generateStyle, generateComponentTheme))(StimulusInfoBase);
export default StimulusInfo;